import { styled } from "styled-components";

export const SkeletonContainer = styled.div`
  width: 100%;
  height: 100%;
  display: ${({ loaded }) => (loaded ? "none" : "flex")};

  .profile-image-skeleton {
    width: 400px;
    height: 400px;
  }
`;

export const ProfileImg = styled.img`
  display: flex;
  border-radius: var(--borderRadius);
  width: 400px;
  border-radius: 10px;
`;
